export default __webpack_public_path__ + "static/media/ib.9e155374.png";